const JOINEE_LOGO = '/community/joinee/assets/favicons/logo_source.svg';

export const MOCK_COMMUNITY = {
    id: 1,
    name: 'Joinee Community',
    slug: 'joinee',
    domain: 'joinee',
    logo: JOINEE_LOGO,
    transparent: true,
    options: ['ENABLE_CAREER_TAB', 'ENABLE_MENTORSHIP', 'ENABLE_FAQ'],
};

export const MOCK_COMMUNITIES = [
    { id: 1, name: 'Joinee Hub', slug: 'joinee', membersCount: '1.4k', badge: 'Active', logo: JOINEE_LOGO },
    { id: 2, name: 'VTB Tech Network', slug: 'vtb', membersCount: '3.8k', badge: 'Partner' },
    { id: 3, name: 'Phystech Alumni', slug: 'phystech', membersCount: '850', badge: 'Private' },
    { id: 4, name: 'Founders & Angels', slug: 'founders', membersCount: '620', badge: 'Invite' },
];

export const MOCK_USER = {
    id: 'usr_99182',
    name: 'Alex Morgan',
    role: 'Community Lead',
    email: 'alex.morgan@joinee.io',
    slug: 'alex-morgan',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80',
    initials: 'AM',
    isAdmin: true,
    hasDonation: false,
};

export const MOCK_NAV_ITEMS = [
    { id: 'communities', to: '/my_communities', label: 'Communities', icon: 'Compass', badge: null },
    { id: 'participants', to: '/participants', label: 'Members', icon: 'Users', badge: null },
    { id: 'contacts', to: '/contacts', label: 'Matches', icon: 'Sparkles', badge: null },
    { id: 'events', to: '/events', label: 'Events', icon: 'Calendar', badge: null },
    { id: 'career', to: '/jobs', label: 'Career', icon: 'Briefcase', badge: 'New', badgeVariant: 'secondary' },
    { id: 'mentorship', to: '/mentorship', label: 'Mentorship', icon: 'GraduationCap', badge: null },
    { id: 'chats', to: '/chats', label: 'Chats', icon: 'MessageSquare', badge: 3, badgeVariant: 'primary' },
    { id: 'faq', to: '/faq', label: 'FAQ', icon: 'HelpCircle', badge: null },
    { id: 'admin', to: '/admin', label: 'Admin', icon: 'Shield', badge: null, adminOnly: true },
];

export const MOCK_LANGUAGES = [
    { code: 'EN', label: 'English' },
    { code: 'RU', label: 'Русский' },
];

export const MOCK_NOTIFICATIONS = [
    {
        id: 1,
        kind: 'event',
        title: 'New event invitation',
        time: '10m ago',
        unread: true,
        to: '/events',
        name: 'Founders Meetup',
        initials: 'EV',
        image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=150&h=150&auto=format&fit=crop&q=80',
    },
    {
        id: 2,
        kind: 'person',
        title: 'Elena sent you a connection request',
        time: '1h ago',
        unread: true,
        to: '/contacts',
        name: 'Elena Rostova',
        initials: 'ER',
        image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80',
    },
    {
        id: 3,
        kind: 'job',
        title: 'New job matching you: Product Designer',
        time: '3h ago',
        unread: false,
        to: '/jobs',
        name: 'Product Designer',
        initials: 'PD',
        image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=150&h=150&auto=format&fit=crop&q=80',
    },
    {
        id: 4,
        kind: 'person',
        title: 'Your profile has 14 new views',
        time: '1d ago',
        unread: false,
        to: '/profile',
        name: 'Sarah Chen',
        initials: 'SC',
        image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&auto=format&fit=crop&q=80',
    },
];
